// imports
import React, { useState } from 'react';
import PinLayer from './pin';
import ImageLayer from './image';
import BannerLayer from './banner';
import MergedPinLayer from './mergePin';
import { World, MapViewState, MapImageQuality } from '../../../common/types';

// interfaces / types / consts
interface Props {
  world: World;
  questPinIds: string[];
  mapViewState: MapViewState;
  imageQuality: MapImageQuality;
  onRegionClicked: (regionId: string) => void;
  onPinClicked: (regionId: string, pinId: string) => void;
}

// exports
export default function Layers(props: Props): JSX.Element {
  const {
    imageQuality, world, mapViewState, questPinIds,
    onRegionClicked, onPinClicked
  } = props;
  // hooks configuration
  const [regionHovered, setRegionHovered] = useState(false);

  // exports
  return (
    <>
      <ImageLayer
        quality={imageQuality}
        mapViewState={mapViewState}
        onRegionClicked={onRegionClicked}
        onRegionHovered={setRegionHovered}
      />
      <BannerLayer
        world={world}
        regionHovered={regionHovered}
        mapViewState={mapViewState}
      />
      {/* {questPinIds.length && mapViewState === 'default' && (
        <MergedPinLayer questCount={questPinIds.length} />
      )} */}
      {/* {questPinIds.length && (
        <PinLayer
          world={world}
          questPinIds={questPinIds}
          mapViewState={mapViewState}
          onPinClicked={onPinClicked}
        />
      )} */}
    </>
  );
}
